import { render, staticRenderFns } from "./case_list.vue?vue&type=template&id=2563eed2&scoped=true"
import script from "./case_list.vue?vue&type=script&lang=js"
export * from "./case_list.vue?vue&type=script&lang=js"
import style0 from "./case_list.vue?vue&type=style&index=0&id=2563eed2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2563eed2",
  null
  
)

export default component.exports